import type { QueryObserverOptions } from '@tanstack/react-query';

/**
 * Common default configuration for queries that have expectedly stable results (snapshot data etc).
 */
export const cachedQueryDefaultOptions = {
  staleTime: 30 * 1000, // 30 seconds
  refetchOnReconnect: false,
  refetchOnWindowFocus: false,
} satisfies Partial<QueryObserverOptions>;
